import { Component, type ReactNode } from 'react';

type Props = { children: ReactNode };
type State = { failed: boolean };

/**
 * Изолирует служебную часть оболочки (мост платформы, тосты, полоса переходов) от самой страницы.
 *
 * Границы маршрутов (`DefaultCatchBoundary`) ловят только то, что внутри маршрута. Эти же
 * компоненты стоят в оболочке рядом с маршрутами, и без границы падение любого хука моста
 * (звонки, push, ссылки) обрушивало бы весь документ в белый экран без единой кнопки. С границей
 * страница остаётся, а отказавшая служебная часть просто пропадает.
 *
 * Событие в GlitchTip отсюда не шлётся: ошибку, пойманную границей, React отдаёт в
 * `onCaughtError` корня (client.tsx), и там она уходит с меткой и стеком компонентов. Второй
 * `captureException` здесь дал бы дубль.
 */
export class ShellIsolation extends Component<Props, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  render() {
    return this.state.failed ? null : this.props.children;
  }
}
